import React, { useState } from "react";

const Register = ({ onRegisterSuccess, onSwitchToLogin }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    username: "",
  });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await fetch("/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({ type: "success", message: "Compte créé avec succès !" });
        setFormData({ email: "", password: "", username: "" });

        if (onRegisterSuccess) {
          // On attend 1s pour que l'utilisateur voit le message de succès
          setTimeout(() => onRegisterSuccess(data), 1000);
        }
      } else {
        setStatus({
          type: "error",
          message: data.detail || "Erreur lors de l'inscription.",
        });
      }
    } catch (error) {
      setStatus({ type: "error", message: "Le serveur ne répond pas." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full p-8 bg-white">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-slate-900">
          Join Scribify
        </h2>
        <p className="text-slate-500 mt-2 text-sm">
        Create your account to continue
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-semibold text-slate-600 mb-1">
            Username
          </label>
          <input
            type="text"
            required
            className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-emerald-500 outline-none transition-all bg-slate-50 text-slate-900"
            placeholder="Ton pseudo"
            value={formData.username}
            onChange={(e) =>
              setFormData({ ...formData, username: e.target.value })
            }
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-slate-600 mb-1">
            Email
          </label>
          <input
            type="email"
            required
            className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100 outline-none transition-all bg-slate-50 text-slate-900"
            placeholder="nom@exemple.com"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-slate-600 mb-1">
            Password
          </label>
          <input
            type="password"
            required
            className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100 outline-none transition-all bg-slate-50 text-slate-900"
            placeholder="••••••••"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-4 rounded-xl font-bold text-white shadow-lg transition-all transform active:scale-95 ${
            loading
              ? "bg-slate-400"
              : "bg-emerald-500 hover:bg-emerald-600 shadow-emerald-200"
          }`}
        >
          {loading ? (
            <div className="flex items-center justify-center space-x-2">
              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
              <span>Processing...</span>
            </div>
          ) : (
            "S'inscrire gratuitement"
          )}
        </button>
      </form>

      {/* Footer de la Modal : Lien de bascule vers Login */}
      <div className="mt-8 pt-6 border-t border-slate-100 text-center">
        <p className="text-slate-500 text-sm">
          Already have an account ?{" "}
          <button
            type="button"
            onClick={onSwitchToLogin}
            className="text-emerald-600 hover:text-emerald-500 font-bold underline-offset-4 hover:underline transition-colors"
          >
            Log in here
          </button>
        </p>
      </div>

      {status.message && (
        <div
          className={`mt-6 p-4 rounded-xl text-sm font-medium text-center ${
            status.type === "success"
              ? "bg-emerald-50 text-emerald-700 border border-emerald-100"
              : "bg-red-50 text-red-700 border border-red-100"
          }`}
        >
          {status.message}
        </div>
      )}
    </div>
  );
};

export default Register;